module.exports = __webpack_public_path__ + "static/media/list-asset.51f3a8fa.png";